import { Workplaces } from "./workplaces.component";
import { Workplace } from "./workplace.component";
import { EditWorkplace } from "./workplace.edit.component";
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UIRouterModule } from "@uirouter/angular";
import { workplacesState, workplaceState, newWorkplaceState, editWorkplaceState } from "./workplaces.states";
import { AllMaterialModule } from "../../all-material.components";
import { FlexLayoutModule } from "@angular/flex-layout";
import SharedModule from "../../shared/shared.module";
import { CoreModule } from "../../core/core.module";
import { ConfirmDialog } from "../../shared/confirm-dialog.component";

let WORKPLACES_STATES = [workplacesState, workplaceState, newWorkplaceState, editWorkplaceState];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        AllMaterialModule,
        SharedModule,
        CoreModule,
        FlexLayoutModule,
        UIRouterModule.forChild({ states: WORKPLACES_STATES })
    ],
    declarations: [Workplaces, Workplace, EditWorkplace],
    entryComponents: [ConfirmDialog]
})
export default class WorkplacesModule {
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/workplaces/workplaces.module.ts